:host {
  display: block;
  max-width: 100%;
}

.wrapper {
  .loading-container {
    display: none;
    justify-content: center;
    align-items: center;
    width: 100%;
    height: 100%;

    gz-progress-spinner {
      display: flex;
      justify-content: center;
    }
  }

  .content-wrapper {
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    position: relative;

    padding-top: calc(var(--spacer) * 4);

    .form-wrapper {
      min-width: 500px;
      width: 100%;
      height: 100%;
      overflow-y: scroll;

      padding-left: calc(var(--spacer) * 5);
      padding-right: var(--spacer);
      padding-bottom: calc(var(--spacer) * 5);
    }

    .bottom-buttons {
      width: 100%;
      flex-basis: 65px;
      min-height: 65px;
      margin-top: auto;
      display: flex;
      align-items: center;

      border-top: 1px solid var(--chart-101-pressed-dividers);

      padding-left: calc(var(--spacer) * 2);
      padding-right: calc(var(--spacer) * 2);

      gz-button {
        margin-right: calc(var(--spacer) * 2);
      }
    }
  }
}

#task-name-form-field {
  margin-bottom: calc(var(--spacer) * 4);
}

gz-submit-to-sandbox-samples-form {
  margin-bottom: calc(var(--spacer) * 4);
}
